// browserDetection.js
// كشف متصفحات التطبيقات (Instagram, Facebook, TikTok, etc.)

/**
 * فحص ما إذا كان المتصفح هو متصفح داخل تطبيق (Instagram, Facebook, etc.)
 */
export const isInAppBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  
  // Instagram in-app browser
  if (ua.includes('Instagram')) {
    return { isInApp: true, platform: 'Instagram' };
  }
  
  // Facebook in-app browser
  if (ua.includes('FBAN') || ua.includes('FBAV')) {
    return { isInApp: true, platform: 'Facebook' };
  }
  
  // TikTok in-app browser
  if (ua.includes('musical_ly') || ua.includes('TikTok')) {
    return { isInApp: true, platform: 'TikTok' };
  }
  
  // Twitter in-app browser
  if (ua.includes('Twitter')) {
    return { isInApp: true, platform: 'Twitter' };
  }
  
  // LinkedIn in-app browser
  if (ua.includes('LinkedInApp')) {
    return { isInApp: true, platform: 'LinkedIn' };
  }

  // Telegram in-app browser
if (ua.includes('Telegram')) {
  return { isInApp: true, platform: 'Telegram' };
}

// ✅ كشف تيليغرام عن طريق غياب Notification API
if (typeof Notification === 'undefined') {
  return { isInApp: true, platform: 'Telegram' };
}

return { isInApp: false, platform: null };
}

/**
 * فتح الرابط في متصفح خارجي
 */
export const openInExternalBrowser = (url = window.location.href) => {
  const browserInfo = isInAppBrowser();
  
  if (!browserInfo.isInApp) {
    console.log('Already in external browser');
    return false;
  }
  
  // محاولة فتح الرابط في متصفح خارجي
  // للأندرويد
  if (navigator.userAgent.includes('Android')) {
    // محاولة فتح في Chrome
    const chromeIntent = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
    window.location.href = chromeIntent;
    
    // إذا لم ينجح، نحاول الطريقة العادية
    setTimeout(() => {
      window.location.href = url;
    }, 500);
  } 
  // للـ iOS
  else if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')) {
    // نسخ الرابط إلى الحافظة
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => {
        alert('تم نسخ الرابط! الصق الرابط في متصفح Safari أو Chrome');
      }).catch(() => {
        // fallback
        window.location.href = url;
      });
    } else {
      // محاولة فتح مباشرة
      window.location.href = url;
    }
  } 
  // أنظمة أخرى
  else {
    window.open(url, '_blank');
  }
  
  return true;
};

/**
 * الحصول على رسالة توضيحية حسب المنصة
 */
export const getInstructionMessage = () => {
  const browserInfo = isInAppBrowser();
  
  if (!browserInfo.isInApp) {
    return null;
  }
  
  const messages = {
    'Instagram': 'يرجى فتح الموقع في متصفح خارجي (Safari أو Chrome) للحصول على تجربة أفضل',
    'Facebook': 'يرجى فتح الموقع في متصفح خارجي (Safari أو Chrome) للحصول على تجربة كاملة',
    'TikTok': 'يرجى فتح الموقع في متصفح خارجي للوصول إلى جميع المميزات',
    'Telegram': 'يرجى فتح الموقع في متصفح خارجي (Safari أو Chrome) للحصول على تجربة كاملة',
    'default': 'يرجى فتح الموقع في متصفح خارجي للحصول على أفضل تجربة'
  };
  
  return messages[browserInfo.platform] || messages.default;
};